import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { ButtonHTMLAttributes } from 'react';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** 활성화 여부 */
  isActive: boolean;
}

const PricingTabButton = ({
  isActive,
  className,
  children,
  ...props
}: Props) => {
  return (
    <Button
      {...props}
      className={cn(
        'typo-16 desktop:typo-20 desktop:w-[150px] desktop:h-[55px] cursor-pointer rounded-full px-9 py-3 font-bold transition',
        isActive ? 'bg-main-yellow text-level-2' : 'bg-[#19191A] text-white',
        className,
      )}
    >
      {children}
    </Button>
  );
};

export default PricingTabButton;
